(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4438],{

/***/ 53117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pop_up_base; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/dialog/dialog.js + 23 modules
var dialog = __webpack_require__(65518);
// EXTERNAL MODULE: ./public/assets/icons/ExitPopUp.svg
var ExitPopUp = __webpack_require__(61740);
;// CONCATENATED MODULE: ./components/atoms/pop-up-base/PopUpBase.tsx



/**
 * PopUpBase
 */ var PopUpBase = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, state = param.state, children = param.children, funcionOnClose = param.funcionOnClose, thumbsChildren = param.thumbsChildren, desc = param.desc, title = param.title, _type = param.type, type = _type === void 0 ? "base" : _type, _bgColor = param.bgColor, bgColor = _bgColor === void 0 ? "#fff" : _bgColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog */.V, {
        open: state,
        onClose: funcionOnClose,
        className: "fixed inset-0 z-50 grid place-items-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog.Overlay */.V.Overlay, {
                className: "fixed inset-0 bg-[rgba(21,33,39,0.7)]",
                onClick: funcionOnClose
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog.Panel */.V.Panel, {
                className: "z-50 flex flex-col items-center overflow-hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex h-full flex-col items-center justify-around gap-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                backgroundColor: "".concat(bgColor, " !important")
                            },
                            className: "flex flex-col rounded-md text-primary-400 sm:justify-around ".concat(type === "galery" ? "bg-transparent sm:bg-white" : "", " h-fit w-full max-w-[calc(100vw-2rem)] p-4 sm:h-auto sm:w-auto sm:p-5 ").concat(className),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mx-2 flex flex-row justify-between gap-4 sm:mb-2 sm:mt-0 ".concat(type === "galery" ? "my-5" : "my-2"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col gap-1",
                                            children: [
                                                title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    className: "text-heading text-heading--h3",
                                                    children: title
                                                }),
                                                desc && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "text-body text-body--secondary--bold",
                                                    children: desc
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ExitPopUp["default"], {
                                            heigth: 32,
                                            width: 32,
                                            className: "flex-shrink-0 hover:cursor-pointer",
                                            onClick: funcionOnClose
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: type === "galery" ? "min-h-[60vh] min-w-[80vw]" : type === "iframe" ? desc ? "relative min-h-[calc(100vh-68px)] min-w-[100vw] sm:min-h-[60vh] sm:min-w-[80vw]" : "relative min-h-[calc(100vh-48px)] min-w-[100vw] sm:min-h-[60vh] sm:min-w-[80vw]" : "h-[60vh] overflow-y-auto sm:h-auto sm:w-auto",
                                    children: children
                                })
                            ]
                        }),
                        thumbsChildren && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-3 min-h-fit sm:mb-0",
                            children: thumbsChildren
                        })
                    ]
                })
            })
        ]
    });
};
PopUpBase.displayName = "PopUpBase";

;// CONCATENATED MODULE: ./components/atoms/pop-up-base/index.ts

/* harmony default export */ var pop_up_base = (PopUpBase);


/***/ }),

/***/ 74637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ atoms_select; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(36045);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(43291);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(57239);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(74772);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(42667);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(89136);
;// CONCATENATED MODULE: ./components/atoms/select/Select.tsx








/**
 * Select
 */ var Select = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _elements = param.elements, elements = _elements === void 0 ? [] : _elements, name = param.name, defaultValue = param.defaultValue, label = param.label, requiredMessage = param.requiredMessage;
    var ref = (0,index_esm/* useFormContext */.Gc)(), register = ref.register, errors = ref.formState.errors, setValue = ref.setValue, trigger = ref.trigger;
    var t = (0,useTranslation/* default */.Z)("common").t;
    var elemntIndex = elements.findIndex(function(elemt) {
        return (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.value) === elemt.value.toString();
    });
    var selectValidation = function(value) {
        return value !== "-1" || "Please select a valid option";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                htmlFor: name,
                className: "text-other--label-form uppercase ".concat(errors[name] && "text-[#ff0000]"),
                children: [
                    label,
                    requiredMessage && " *"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                id: name
            }, register(name, (0,_object_spread/* default */.Z)({}, requiredMessage !== undefined ? {
                required: requiredMessage,
                validate: selectValidation
            } : {
                required: requiredMessage
            }))), {
                name: name,
                defaultValue: elemntIndex !== -1 ? defaultValue ? defaultValue.value : 0 : elemntIndex,
                className: "text-body ".concat(errors[name] ? "border-[#ff0000] text-[#ff0000] placeholder-[#ff0000]" : "text-body--primary border-primary-400 text-primary-400 placeholder-primary-400", "   w-full cursor-pointer border-b  bg-transparent pb-2  outline-none ").concat(className),
                onChange: function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    setValue(name, e.target.value);
                                    return [
                                        4,
                                        trigger(name)
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(e) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                children: [
                    defaultValue && elemntIndex === -1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: defaultValue.value,
                        children: defaultValue.label
                    }) : null,
                    elements === null || elements === void 0 ? void 0 : elements.map(function(child, index) {
                        return /*#__PURE__*/ (0,react.createElement)("option", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, child.disabled && {
                            disabled: true
                        }), {
                            className: "w-full",
                            key: index,
                            value: child.value,
                            children: [
                                child.label,
                                child.disabled ? t("components.atoms.select.soon") : ""
                            ]
                        }));
                    })
                ]
            })),
            errors[name] && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "text-other--detail text-[#ff0000]",
                children: errors[name].message
            })
        ]
    });
};
Select.displayName = "Select";

;// CONCATENATED MODULE: ./components/atoms/select/index.ts

/* harmony default export */ var atoms_select = (Select);


/***/ }),

/***/ 80735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pop_up_booking_lavanda; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(89136);
// EXTERNAL MODULE: ./components/atoms/pop-up-base/index.ts + 1 modules
var pop_up_base = __webpack_require__(53117);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(43291);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(57239);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(42667);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(96052);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(46572);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/atoms/select/index.ts + 1 modules
var atoms_select = __webpack_require__(74637);
// EXTERNAL MODULE: ./components/atoms/button/index.ts + 1 modules
var atoms_button = __webpack_require__(60825);
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.min.js
var react_datepicker_min = __webpack_require__(32827);
var react_datepicker_min_default = /*#__PURE__*/__webpack_require__.n(react_datepicker_min);
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.css
var react_datepicker = __webpack_require__(18698);
// EXTERNAL MODULE: ./components/molecules/date-picker/DatePicker.module.css
var DatePicker_module = __webpack_require__(10639);
var DatePicker_module_default = /*#__PURE__*/__webpack_require__.n(DatePicker_module);
;// CONCATENATED MODULE: ./components/molecules/date-picker/DatePicker.tsx






/**
 * DatePicker
 */ var DatePicker = function(_param) /*#__PURE__*/ {
    var _className = _param.className, className = _className === void 0 ? "" : _className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)("div", {
        className: (DatePicker_module_default())["date-picker"],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((react_datepicker_min_default()), (0,_object_spread/* default */.Z)({
            className: "text-body--primary font-thin text-text-primary ".concat(className)
        }, props))
    });
};
DatePicker.displayName = "DatePicker";

;// CONCATENATED MODULE: ./components/molecules/date-picker/index.ts

/* harmony default export */ var date_picker = (DatePicker);

;// CONCATENATED MODULE: ./lib/utils/lavanda.ts
var generateBookingURL = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, startDate = ref.startDate, endDate = ref.endDate, building = ref.building, apartment = ref.apartment;
    var _NEXT_PUBLIC_LAVANDA_BOOK;
    var url = new URL((_NEXT_PUBLIC_LAVANDA_BOOK = "https://book.becasaessential.com/es/properties?") !== null && _NEXT_PUBLIC_LAVANDA_BOOK !== void 0 ? _NEXT_PUBLIC_LAVANDA_BOOK : "");
    if (startDate) url.searchParams.set("from", startDate);
    if (endDate) url.searchParams.set("to", endDate);
    if (building) url.searchParams.set("building_name", building);
    if (apartment) url.searchParams.set("number_of_bedrooms", apartment);
    return url.href;
};

// EXTERNAL MODULE: ./lib/utils/gtm/helpers.ts
var helpers = __webpack_require__(47675);
;// CONCATENATED MODULE: ./components/molecules/booking-lavanda/BookingLavanda.tsx












/**
 * BookingLavanda
 */ var BookingLavanda = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, apartmentsByBuilding = param.apartmentsByBuilding, buildings = param.buildings, defaultApartment = param.defaultApartment, defaultBuilding = param.defaultBuilding, province = param.province;
    var ref;
    var t = (0,useTranslation/* default */.Z)("common").t;
    var ref1 = (0,react.useState)(true), buttonDisabled = ref1[0], setButtonDisabled = ref1[1];
    var ref2;
    var ref3 = (0,react.useState)((ref2 = defaultBuilding === null || defaultBuilding === void 0 ? void 0 : defaultBuilding.hasDepartureDate) !== null && ref2 !== void 0 ? ref2 : false), hasDepartureDate = ref3[0], setHasDepeartureDate = ref3[1];
    var _ref = (0,index_esm/* useForm */.cI)(), handleSubmit = _ref.handleSubmit, watch = _ref.watch, register = _ref.register, setValue = _ref.setValue, methods = (0,_object_without_properties/* default */.Z)(_ref, [
        "handleSubmit",
        "watch",
        "register",
        "setValue"
    ]);
    var onSubmit = function(data) {
        var ref;
        var buildingName = (ref = buildings.find(function(building) {
            return building.id === parseInt(data.building);
        })) === null || ref === void 0 ? void 0 : ref.value;
        if (data.apartment === "-1") {
            data.apartment = "";
        }
        var url = generateBookingURL((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
            building: buildingName
        }));
        url = url.replace(/%2B/g, "+");
        var ref1, ref2;
        (0,helpers/* gtmPush */.De)({
            event: "availability_search",
            provincia: (ref1 = province === null || province === void 0 ? void 0 : province.label) !== null && ref1 !== void 0 ? ref1 : "",
            edificio: (ref2 = defaultBuilding === null || defaultBuilding === void 0 ? void 0 : defaultBuilding.label) !== null && ref2 !== void 0 ? ref2 : "",
            alojamiento: data.apartment,
            fecha: data.startDate
        });
        window.open(url, "_blank", "noopener noreferrer");
    };
    var buildingsSelectValues = buildings.map(function(building) {
        return {
            label: building.label,
            value: building.id,
            disabled: building.disabled
        };
    });
    var mapOfAccommodation = new Map(apartmentsByBuilding);
    var watchBuilding = watch("building", defaultBuilding === null || defaultBuilding === void 0 ? void 0 : (ref = defaultBuilding.value) === null || ref === void 0 ? void 0 : ref.toString());
    var ref4 = (0,react.useState)(null), startDate = ref4[0], setStartDate = ref4[1];
    var ref5 = (0,react.useState)(null), endDate = ref5[0], setEndDate = ref5[1];
    var values = methods.getValues();
    (0,react.useEffect)(function() {
        setButtonDisabled(!(values === null || values === void 0 ? void 0 : values.building) || (values === null || values === void 0 ? void 0 : values.building) === "-1" ? true : false);
        var flag = false;
        buildings.forEach(function(build) {
            if ("".concat(values === null || values === void 0 ? void 0 : values.building) === "".concat(build.id)) {
                flag = build.hasDepartureDate;
            }
        });
        if (flag) {
            setHasDepeartureDate(true);
        } else {
            setHasDepeartureDate(false);
        }
    }, [
        values
    ]);
    var getDates = function(from) {
        if (!from) {
            // return [new Date().now(), new Date().now()];
            return [];
        }
        var to = new Date(from).setMonth(from.getMonth() + 1);
        var cFrom = new Date(from);
        var cTo = new Date(to);
        var daysArr = [
            new Date(cFrom)
        ];
        var tempDate = cFrom;
        while(tempDate < cTo){
            tempDate.setUTCDate(tempDate.getUTCDate() + 1);
            daysArr.push(new Date(tempDate));
        }
        return daysArr;
    };
    (0,react.useEffect)(function() {
        var ref;
        var ref1;
        setValue("building", (ref1 = defaultBuilding === null || defaultBuilding === void 0 ? void 0 : (ref = defaultBuilding.value) === null || ref === void 0 ? void 0 : ref.toString()) !== null && ref1 !== void 0 ? ref1 : "");
        if (defaultApartment) {
            var ref2;
            var ref3;
            setValue("apartment", (ref3 = defaultApartment === null || defaultApartment === void 0 ? void 0 : (ref2 = defaultApartment.value) === null || ref2 === void 0 ? void 0 : ref2.toString()) !== null && ref3 !== void 0 ? ref3 : "");
        }
        setButtonDisabled(!(values === null || values === void 0 ? void 0 : values.building) || (values === null || values === void 0 ? void 0 : values.building) === "-1" ? true : false);
    }, []);
    var ref6;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative mt-5 rounded-md bg-surface-00 p-4 pt-8 shadow-md md:mt-7 ".concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute right-4 top-0 -translate-y-1/2 md:right-14",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "u-aspect-square relative w-10 md:w-14",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/assets/img/logo/logo-brown.svg",
                        alt: "logo",
                        objectFit: "contain",
                        layout: "fill"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                handleSubmit: handleSubmit,
                register: register,
                setValue: setValue,
                watch: watch
            }, methods), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    onSubmit: handleSubmit(onSubmit),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mb-6 flex flex-col gap-8",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_select/* default */.Z, {
                                    label: t("components.molecules.bookingLavanda.building"),
                                    name: "building",
                                    elements: buildingsSelectValues,
                                    defaultValue: defaultBuilding
                                }),
                                !hasDepartureDate && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_select/* default */.Z, (0,_object_spread/* default */.Z)({
                                    label: t("components.molecules.bookingLavanda.typeOfApartment"),
                                    name: "apartment",
                                    elements: (ref6 = mapOfAccommodation.get(parseInt(watchBuilding === null || watchBuilding === void 0 ? void 0 : watchBuilding.toString()))) !== null && ref6 !== void 0 ? ref6 : []
                                }, defaultApartment && {
                                    defaultValue: defaultApartment
                                })),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            className: "text-other--label-form uppercase",
                                            htmlFor: "date",
                                            children: hasDepartureDate ? t("components.molecules.bookingLavanda.whenDeparture") : t("components.molecules.bookingLavanda.when")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(date_picker, (0,_object_spread/* default */.Z)({
                                            minDate: new Date(),
                                            dateFormat: "dd/MM/yyyy",
                                            placeholderText: hasDepartureDate ? t("components.molecules.bookingLavanda.whenPlaceholderDeparture") : t("components.molecules.bookingLavanda.whenPlaceholder"),
                                            customInput: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                id: "date",
                                                name: "date",
                                                readOnly: true,
                                                className: "text-body--primary w-full cursor-pointer border-b border-primary-400 py-2 font-thin text-text-primary placeholder:text-text-primary"
                                            })
                                        }, hasDepartureDate ? {
                                            startDate: startDate,
                                            endDate: endDate,
                                            selectsRange: true,
                                            excludeDates: getDates(startDate),
                                            selectsDisabledDaysInRange: true,
                                            onChange: function(dates) {
                                                var ref, ref1;
                                                if (!Array.isArray(dates)) return;
                                                setStartDate(dates[0]);
                                                var ref2;
                                                setValue("startDate", "".concat((ref2 = (ref = dates[0]) === null || ref === void 0 ? void 0 : ref.toLocaleDateString("sv")) !== null && ref2 !== void 0 ? ref2 : ""));
                                                setEndDate(dates[1]);
                                                var ref3;
                                                setValue("endDate", "".concat((ref3 = (ref1 = dates[1]) === null || ref1 === void 0 ? void 0 : ref1.toLocaleDateString("sv")) !== null && ref3 !== void 0 ? ref3 : ""));
                                            }
                                        } : {
                                            selected: startDate,
                                            onChange: function(date) {
                                                if (date !== null) {
                                                    setStartDate(date);
                                                    var ref;
                                                    setValue("startDate", "".concat((ref = date === null || date === void 0 ? void 0 : date.toLocaleDateString("sv")) !== null && ref !== void 0 ? ref : ""));
                                                    var temp = new Date(date);
                                                    temp.setFullYear(date.getFullYear() + 1);
                                                    var ref1;
                                                    setValue("endDate", "".concat((ref1 = temp === null || temp === void 0 ? void 0 : temp.toLocaleDateString("sv")) !== null && ref1 !== void 0 ? ref1 : ""));
                                                    setEndDate(null);
                                                }
                                            }
                                        })),
                                        hasDepartureDate && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-start text-xs font-thin text-text-secondary",
                                            children: t("components.molecules.bookingLavanda.departureDisclaimer")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                    hidden: true,
                                    readOnly: true,
                                    type: "date"
                                }, register("startDate"))),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                    hidden: true,
                                    readOnly: true,
                                    type: "date"
                                }, register("endDate")))
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                            type: "submit",
                            variant: "secondary",
                            size: "small",
                            className: "mx-auto mb-6 w-full md:w-1/2",
                            disabled: buttonDisabled,
                            children: t("components.molecules.bookingLavanda.viewApartments")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "text-body--secondary text-center font-thin text-text-primary",
                            children: [
                                t("components.molecules.bookingLavanda.needHelp"),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: t("components.molecules.bookingLavanda.contactLink"),
                                    passHref: true,
                                    prefetch: false,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "text-status-warning",
                                        children: t("components.molecules.bookingLavanda.contact")
                                    })
                                })
                            ]
                        })
                    ]
                })
            }))
        ]
    });
};
BookingLavanda.displayName = "BookingLavanda";

;// CONCATENATED MODULE: ./components/molecules/booking-lavanda/index.ts

/* harmony default export */ var booking_lavanda = (BookingLavanda);

;// CONCATENATED MODULE: ./components/organisms/pop-up-booking-lavanda/PopUpBookingLavanda.tsx




/**
 * PopUpBookingLavanda
 */ var PopUpBookingLavanda = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, apartmentsByBuilding = param.apartmentsByBuilding, buildings = param.buildings, onClose = param.onClose, show = param.show, province = param.province, defaultApartment = param.defaultApartment, defaultBuilding = param.defaultBuilding;
    var t = (0,useTranslation/* default */.Z)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(pop_up_base["default"], {
        state: show,
        funcionOnClose: onClose,
        className: "bg-surface-01 text-text-primary md:min-w-[500px] ".concat(className),
        title: t("components.organisms.popUpBookingLavanda.title"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-body--primary mb-4 inline-block font-thin md:mb-6",
                children: t("components.organisms.popUpBookingLavanda.description")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(booking_lavanda, {
                buildings: buildings,
                apartmentsByBuilding: apartmentsByBuilding,
                defaultApartment: defaultApartment,
                defaultBuilding: defaultBuilding,
                province: province
            })
        ]
    });
};
PopUpBookingLavanda.displayName = "PopUpBookingLavanda";

;// CONCATENATED MODULE: ./components/organisms/pop-up-booking-lavanda/index.ts

/* harmony default export */ var pop_up_booking_lavanda = (PopUpBookingLavanda);


/***/ }),

/***/ 10639:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"date-picker":"DatePicker_date-picker__bqTIK"};

/***/ })

}]);